/* @flow */

import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { EditUser } from "shared/utils";

import { Container } from "./styles";

const ActionButtons = (props) => {
  const {
    onPreTransactionClicked,
    onTransactionClicked,
    onSnoozeClicked,
    onUnsnoozeClicked,
    onIgnoreClicked,
    onUnignoreClicked,
    eventType,
    rowsSelected,
    variant = "outlined",
    className,
  } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const editUser = EditUser();
  const isDisabled = !rowsSelected || !editUser;

  const handleOpen = (event) => {
    if (isDisabled) return;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuAction = (callback) => {
    handleClose();
    if (typeof callback === "function") callback();
  };

  const renderMenuItems = () => {
    switch (eventType) {
      case "all":
        return (
          <>
            <MenuItem
              onClick={() => handleMenuAction(onPreTransactionClicked)}
              disabled={!editUser}
            >
              Start pre-transaction
            </MenuItem>
            <MenuItem
              onClick={() => handleMenuAction(onTransactionClicked)}
              disabled={!editUser}
            >
              Start transaction
            </MenuItem>
            <MenuItem
              onClick={() => handleMenuAction(onSnoozeClicked)}
              disabled={!editUser}
            >
              Snooze
            </MenuItem>
            <MenuItem
              onClick={() => handleMenuAction(onIgnoreClicked)}
              disabled={!editUser}
            >
              Ignore
            </MenuItem>
          </>
        );

      case "snoozed":
        return (
          <MenuItem
            onClick={() => handleMenuAction(onUnsnoozeClicked)}
            disabled={!editUser}
          >
            Unsnooze
          </MenuItem>
        );

      case "ignored":
        return (
          <MenuItem
            onClick={() => handleMenuAction(onUnignoreClicked)}
            disabled={!editUser}
          >
            Unignore
          </MenuItem>
        );

      default:
        return null;
    }
  };

  return (
    <Container className={className}>
      <Button
        className={`cta-button actions-dropdown-button ${variant === "filled" ? "actions-dropdown-button-filled" : ""}`}
        variant={variant === "filled" ? "contained" : "outlined"}
        size="small"
        endIcon={<KeyboardArrowDownIcon />}
        onClick={handleOpen}
        disabled={isDisabled}
        aria-controls={open ? "lease-events-actions-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        Actions
      </Button>
      <Menu
        id="lease-events-actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 200,
            boxShadow: "0px 4px 16px 0px rgba(1, 21, 29, 0.12)",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            "& .MuiMenuItem-root": {
              fontFamily: "Source Sans Pro",
              fontSize: "16px",
              fontWeight: 400,
              color: "#01151D",
              padding: "12px 16px",
              lineHeight: "24px",
              "&:hover": {
                backgroundColor: "rgba(9, 119, 158, 0.07)",
              },
            },
          },
        }}
      >
        {renderMenuItems()}
      </Menu>
    </Container>
  );
};

export default ActionButtons;
